import { combineReducers } from "redux";
import authReducer from "./authReducer";
import errorReducer from "./errorReducer";
import _preferencesReducer from "./_preferenceReducer";
import structureReducer from "./structureReducer";

export default combineReducers({
  auth: authReducer,
  errors: errorReducer,
  structures: structureReducer,
  _preferences: _preferencesReducer
});
